import { Children, useEffect, useState } from "react";
import { useContextComissoes } from "src/Contexts/comissoes/ComissoesContext";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useResetInputs } from "src/Contexts/hooks/useResetInputs";
import { ModalDeleteCore, TableCore, TdCore } from "src/Pages/components";
import { UseVerifyIsPermissionsUser } from "src/Pages/components/hooks/UseVerifyIsPermissionsUser";
import {
  EditIcon,
  CheckIcon,
  CloseIcon,
  DeleteForeverIcon,
  AddHomeWorkIcon,
  FolderOffIcon,
  FolderCopyIcon,
} from "src/Pages/components/Icons/Icons";
import { UseDelete } from "src/Pages/components/ModalDeleteCore/Hooks/UseDelete";
import { TableRowCore } from "src/Pages/components/table/@Core/TableRowCore/TableRowCore";
import { ActionPopoverTable } from "src/Pages/components/table/ActionPopover/ActionPopover";
import { valuesPermissions } from "src/shared/Utils/ValuesPermissions";

import { useHttpTableModalidade } from "./Hooks/useHttpTableModalidade";
import { THeadModalidade } from "./THead";
import { ModalModalidade } from "../Form";
import { ModalChangeIsActiveModalidade } from "../ChangeIsActiveModalidade/ModalChanceIsActiveModalidade";

export const TableModalidade = () => {
  const { listModalidade, setValuesInputsModalidade } = useContextComissoes();
  const { handleVerifyPermissionItem } = UseVerifyIsPermissionsUser();
  const { handleGet } = useHttpTableModalidade();

  const {
    setNameSearch,
    itensPerPage,
    currentPage,
    nameSearch,
    attTable,
    setId,
    setIdTable,
  } = useConfigPageContext();

  const [openModalModalidade, setOpenModalModalidade] = useState(false);
  const [openModalActiveModalidade, setOpenModalActiveModalidade] =
    useState(false);
  const [valueActiveModalidade, setValueActiveModalidade] =
    useState<boolean>(true);
  

  const handleGetIdToEdit = (id: string, modalidade: string) => {
    setIdTable(id);
    setId(id);
    setOpenModalModalidade(true);
    setValuesInputsModalidade({ name: modalidade, is_active: true });
  };

  useEffect(() => {
    handleGet({ itensPerPage, currentPage, nameSearch });
  }, [attTable, itensPerPage, currentPage, nameSearch]);

  const {
    handleDelete,
    open: openModalDelete,
    loading: loadingDelete,
    setId: setIdModalDelete,
    setOpen: setOpenModalDelete,
  } = UseDelete({ url: "/comissoes/modalidade" });

  return (
    <TableCore
      Modals={
        <>
          <ModalDeleteCore
            loading={loadingDelete}
            modalOpen={openModalDelete}
            no="Não, Cancelar"
            titlePrimary="Você deseja excluir da lista ?"
            yes="Sim, Deletar !"
            onClickFalse={() => setOpenModalDelete(false)}
            onClickTrue={() => handleDelete()}
            />
            <ModalChangeIsActiveModalidade
              isActiveModalidade={valueActiveModalidade}
              modalIsActiveModalidade={openModalActiveModalidade}
              setModalIsActiveModalidade={setOpenModalActiveModalidade}
            />
        </>
      }
      THead={<THeadModalidade />}
      qtdList={listModalidade.length}
      setNameSearch={setNameSearch}
      cardAdd={{
              title: "Modalidades",
              icon: <AddHomeWorkIcon color="primary" />,
              buttonAdd: [
                <ModalModalidade
                  key={1}
                  openModal={openModalModalidade}
                  setOpenModal={setOpenModalModalidade}
                />,
              ],
            }}
    >
      {Children.toArray(
        listModalidade.map((item) => {
          return (
            <TableRowCore id={String(item.code)}>
              <TdCore
                values={
                  <ActionPopoverTable
                    optionsList={[
                      {
                        icon: <EditIcon fontSize="small" />,
                        title: "Editar",
                        background: "warning",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.MODALIDADE.EDITAR.id
                        ),
                        onClick: () => {
                          handleGetIdToEdit(String(item.code), item.name);
                        },
                      },
                      {
                        icon: item.is_active ? (
                          <FolderOffIcon fontSize="small" />
                        ) : (
                          <FolderCopyIcon fontSize="small" />
                        ),
                        background: "warning",
                        title: item.is_active ? "Desativar" : "Ativar",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.MODALIDADE.EDITAR.id
                        ),
                        onClick: () => {
                          setId(String(item.code));
                          setValuesInputsModalidade({
                            name: item.name,
                            is_active: !item.is_active,
                          });
                          setOpenModalActiveModalidade(true);
                          setValueActiveModalidade(!item.is_active);
                        },
                      },
                      {
                        icon: <DeleteForeverIcon fontSize="small" />,
                        title: "Excluir",
                        background: "error",
                        isDisabled: handleVerifyPermissionItem(
                          valuesPermissions.MODALIDADE.DELETAR.id
                        ),
                        onClick: () => {
                          setIdModalDelete(item.code);
                          setOpenModalDelete(true);
                        },
                      },
                    ]}
                  />
                }
              />
              <TdCore
                values={`${item.code} - ${item.name}`}
              />
              <TdCore
                textAlign="left"
                values={
                  item.is_active ? (
                    <CheckIcon color="success" />
                  ) : (
                    <CloseIcon color="error" />
                  )
                }
              />
            </TableRowCore>
          );
        })
      )}
    </TableCore>
  );
};
